var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable global-require */
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FeatureFlagProvider } from '../../context/FeatureFlag';
import alertsTriggerAnalyticsEvent, { analyticsHelper } from '../../helpers/analyticsMiddleware';
import SyfStorage from '../../helpers/SyfStorage';
import { setAppConfig } from '../../redux/appConfig/reducer';
import store from '../../redux/store';
import { useAccountsInfoData, useAlerts } from '../../ui/customHooks';
import AlertsLazyLoader from '../../ui/molecules/AlertsLazyLoader';
import '../../const/iconLibrary';
import VistaApp from '../VistaApp';
export var MainPage = function () {
    var appConfig = useAlerts().appConfig;
    var hasAccountsDataLoaded = appConfig.hasAccountsDataLoaded;
    return (_jsx("div", { children: !hasAccountsDataLoaded ? _jsx(AlertsLazyLoader, {}) : _jsx(VistaApp, {}) }));
};
var SyfAlerts = function (_a) {
    var platform = _a.platform, alertType = _a.alertType, config = _a.config, handleProfileClick = _a.handleProfileClick, accountSummaryKeys = _a.accountSummaryKeys;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var _c = useAccountsInfoData(config, platform, accountSummaryKeys), accountsInfo = _c.data, isLoading = _c.isLoading;
    var errorMessage = t('errorPage.accountsDataNotAvailable');
    var currentLanguage = SyfStorage.getLanguage();
    useEffect(function () {
        var _a;
        i18n.changeLanguage(currentLanguage);
        if ((accountsInfo === null || accountsInfo === void 0 ? void 0 : accountsInfo.length) < 1) {
            alertsTriggerAnalyticsEvent({
                pnl: analyticsHelper.pnl[platform],
                siteIdentifier: analyticsHelper.siteIdentifier[platform],
                message: 'alerts-pageload',
                countryLanguage: "us|".concat(currentLanguage),
                token: SyfStorage.getCorrelationId(),
                errorMessage: errorMessage
            });
            var accountsInfoError = new Error("Alerts - Unable to retrieve accounts information");
            (_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.noticeError(accountsInfoError);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLanguage, platform]);
    useEffect(function () {
        var _a;
        if (!isLoading) {
            store.dispatch(setAppConfig({
                platform: platform,
                alertType: alertType,
                accountsInfo: accountsInfo,
                apiHost: String((_a = config === null || config === void 0 ? void 0 : config.hosts) === null || _a === void 0 ? void 0 : _a.apigee),
                config: config,
                handleProfileClick: handleProfileClick,
                hasAccountsDataLoaded: !isLoading
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform, isLoading]);
    return (_jsx(Provider, __assign({ store: store }, { children: _jsx(FeatureFlagProvider, { children: _jsx(MainPage, {}) }) })));
};
export default SyfAlerts;
